// Dias de visita da conta (só datas AAAA-MM-DD, nunca dado de calculadora, de paciente ou de saúde).
// Serve para avisar o servidor, uma única vez, que a pessoa voltou em outro dia (sinal do LeadQualificado).
const KEY = 'mm_visit_days';
const SENT_KEY = 'mm_return_sent';
const MAX_DAYS = 30;

export function todayKey(now = new Date()) {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

function read(storage, key) {
  try { return storage.getItem(key); } catch { return null; }
}
function write(storage, key, value) {
  try { storage.setItem(key, value); } catch { /* storage indisponível: sem sinal, sem erro */ }
}

/**
 * Registra o dia de hoje e diz se este é um retorno ainda não avisado (há visita registrada em dia anterior).
 * Devolve true no máximo uma vez por navegador.
 */
export function registerVisitAndCheckReturn(storage, now = new Date()) {
  if (!storage) return false;
  const today = todayKey(now);
  let days = [];
  try {
    const parsed = JSON.parse(read(storage, KEY) || '[]');
    days = Array.isArray(parsed) ? parsed.filter((d) => /^\d{4}-\d{2}-\d{2}$/.test(d)) : [];
  } catch { days = []; }
  const returned = days.some((d) => d !== today);
  if (!days.includes(today)) days = [...days, today].slice(-MAX_DAYS);
  write(storage, KEY, JSON.stringify(days));
  if (!returned || read(storage, SENT_KEY) === '1') return false;
  write(storage, SENT_KEY, '1');
  return true;
}
